<template>
  <div class="product-tab-container">
    <div class="product-tab">
      <div class="class-menu-container">
        <div @click="backHome" class="home-tab">首頁</div>
        <v-tabs
          class="class-menu"
          center-active
          hide-slider
          v-model="internalSelectedTab"
        >
          <v-tab
            class="class-menu__item"
            v-for="(item, index) in categories"
            :key="String(index) + item.name"
          >
            {{ item.name }}
          </v-tab>
        </v-tabs>
      </div>
      <div v-if="categories.length" class="function-container">
        <div class="function">
          <img
            :src="arrowImage"
            alt="arrow-image"
            class="function__collaspe-arrow"
            :class="{ show: internalShowCategoryMenu }"
            @click="toggleCategoryMenu"
          />

          <!-- <img :src="archiveImage" alt="archive" class="function__archive" /> -->
        </div>
      </div>
      <div @click="toTicket" class="ticket">
        <img src="@/assets/img/ticket.svg" />
      </div>
    </div>
    <div
      class="category-menu"
      :class="{ 'show-menu': internalShowCategoryMenu }"
    >
      <div
        class="category-menu__item"
        :class="{ selected: internalSelectedTab === index }"
        v-for="(item, index) in categories"
        :key="'menu-tiem-' + String(index) + item.name"
        @click="updateTabValue(index)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductTab',
  props: {
    categories: {
      type: Array,
      default: () => [{ name: '全部類別', value: 0 }],
    },
    selectedTab: {
      type: Number,
      default: 0,
    },
    showCategoryMenu: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    arrowImage: require('@/assets/img/arrow-down-blue.svg'),
    archiveImage: require('@/assets/img/ticket.svg'),
    internalSelectedTab: 0,
    internalShowCategoryMenu: false,
    showOverlay: false,
  }),
  created() {
    this.internalSelectedTab = this.selectedTab
    this.internalShowCategoryMenu = this.showCategoryMenu
  },
  watch: {
    internalSelectedTab(newVal) {
      this.$emit('update:selectedTab', newVal)
    },
    internalShowCategoryMenu(newVal) {
      this.$emit('update:showCategoryMenu', newVal)
    },
    showCategoryMenu(newVal) {
      this.internalShowCategoryMenu = newVal
      this.showOverlay = newVal
    },
  },
  methods: {
    toTicket() {
      window.location = process.env.VUE_APP_LINK_TICKETS
    },
    toggleCategoryMenu() {
      this.internalShowCategoryMenu = !this.internalShowCategoryMenu
    },
    updateTabValue(index) {
      this.internalSelectedTab = index
      this.toggleCategoryMenu()
    },
    backHome() {
      if (localStorage.getItem('source') === 'e7g') {
        window.location = process.env.VUE_APP_E7G_HOME
      } else {
        this.$router.replace({ name: 'home' })
      }
    },
    handleScroll(e) {
      e.stopPropagation()
      console.log(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.product-tab {
  height: 50px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 110;
  color: #222222;
  box-shadow: 0 1px 0 0 #dddddd;
  display: inline-flex;

  .class-menu-container {
    display: inline-flex;
    width: 69.6%;
    height: 100%;
    flex-grow: 1;
  }
  .home-tab {
    display: flex;
    font-size: 14px;
    color: #989898;
    text-align: center;
    width: 61px;
    height: 50px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    line-height: normal;
  }
  .class-menu {
    height: 100%;
    display: flex;
    flex: 1 0 auto;
    position: relative;
    white-space: nowrap;
    width: 76%;
    ::v-deep .v-item-group {
      height: 100%;
    }
    ::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
      display: none !important;
      background: red;
    }
    &__item {
      min-width: 0;
      padding: 0 10px;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #989898;

      &:first-of-type {
        padding-left: 18px;
      }

      &.v-tab--active {
        color: #1da7fc;

        &::before {
          background: none;
        }
      }
    }
  }

  .function-container {
    display: inline-block;
    width: 50px;

    padding: 0 16px;
    // width: 30.4%;
    height: 100%;
    background-color: #fff;
    z-index: 1;

    .function {
      position: relative;
      display: flex;
      width: 100%;
      height: 48px;
      justify-content: space-around;
      align-items: center;

      &__collaspe-arrow {
        width: 24px;
        transition: 300ms;

        &.show {
          transform: rotate(180deg);
        }
      }
      &__archive {
        width: 24px;
      }
    }
  }
  .ticket {
    width: 28px;
    padding: 11px 0;
    margin-right: 18px;
  }
}

.category-menu {
  max-height: 0;
  opacity: 0;
  position: fixed;
  z-index: -1;
  top: 50px;
  width: 100%;
  background-color: white;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  overflow: scroll;

  transition: height 300ms, max-height 300ms, opacity 300ms, z-index 0ms 250ms;

  &__item {
    height: 0;
    opacity: 0;
    padding: 13px 20px;
    position: relative;
    box-shadow: inset 0 1px 0 0 #ededed;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #545454;

    transition: height 300ms, max-height 300ms, opacity 300ms, z-index 0ms 250ms;
  }

  &.show-menu {
    max-height: 48vh;
    opacity: 1;
    z-index: 110;

    transition: height 300ms, max-height 300ms, opacity 300ms, z-index 0ms 0ms;

    .category-menu__item {
      height: 47px;
      opacity: 1;

      transition: height 300ms, max-height 300ms, opacity 300ms, z-index 0ms 0ms;

      &.selected {
        color: #1da7fc;
      }
    }
  }
}
</style>
